var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml-1 tooltip-trigger"},[_c('TooltipIcon',{attrs:{"id":(_vm.id + "-tooltip")}}),_c('b-tooltip',{attrs:{"target":(_vm.id + "-tooltip"),"triggers":"hover","placement":"right"}},[_vm._v(" "+_vm._s(_vm.info)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }